/*
充电成功率--按月呈现
 */
import React, { Component } from "react";
import Echarts from "echarts";
import ScGridTable from "@/components/display/table/gridTableCore";
import { Spin, Tooltip, Button } from "antd";
import ExportJsonExcel from 'js-export-excel';
import { QuestionCircleFilled } from "@ant-design/icons";

class OrderNumType extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = {
      areaList:[],
      quanguoCityArry:[],
      btnType: 1, // 按钮状态。 1图2表
      tableConfig: null,
    };
  }

  /**
   * 初始化页面方法
   */
  componentDidMount() {
    // 默认加载
    this.stubIntactChart(this.props.dataSource);
  }

  componentWillMount() {
    // 预设表单配置项，防止gridTableCore初始化失败
    this.initTableConfig(this.props.dataSource);
  }

  
  handleClick = () => {
   
    var option={};
    let dataTable = [];
    if (this.props.dataSource) {
      for (let i in this.props.dataSource) {
        let obj = {}
        obj['日期'] = this.props.dataSource[i]['day_info'];
        obj['订单数'] = this.props.dataSource[i]['total_num'];
        obj['异常订单数'] = this.props.dataSource[i]['error_num'];
        obj['成功订单数'] = this.props.dataSource[i]['success_num'];
        obj['成功率'] = this.props.dataSource[i]['rate'] + '%';
        dataTable.push(obj);
      }
    }
    var header = ['日期', '订单数', '异常订单数', '成功订单数', '成功率'];
    option.fileName = '订单统计数据导出'
    option.datas=[
      {
        sheetData:dataTable,
        sheetName:'sheet',
        sheetFilter:header,
        sheetHeader:header,
      }
    ];

    var toExcel = new ExportJsonExcel(option); 
    toExcel.saveExcel(); 
  };

  /**
   * 父组件参数修改后，子组件调用方法
   */
  componentWillReceiveProps(nextProps) {
    // 如果数据源改变，则重新渲染图表
    if (JSON.stringify(nextProps.dataSource) !== JSON.stringify(this.props.dataSource)) {
      if (this.state.btnType === 1) {
        this.stubIntactChart(nextProps.dataSource);
      } else {
        this.initTableConfig(nextProps.dataSource);
      }
    }
  }

  /** */
  initTableConfig = (dataSource) => {
    this.setState({
      tableConfig: {
        tableKey: "orderNumTypeTable",
        tableColumns: [
          {
            name: "日期",
            key: "day_info",
            colType: "textCol",
            align: "center",
          },
          {
            name: "订单数",
            key: "total_num",
            colType: "textCol",
            align: "center",
          },
          {
            name: "异常订单数",
            key: "error_num",
            colType: "textCol",
            align: "center",
          },
          {
            name: "成功订单数",
            key: "success_num",
            colType: "textCol",
            align: "center",
          },
          {
            name: "成功率",
            key: "rate",
            colType: "textCol",
            align: "center",
            render: (text) => {
              return `${text}%`;
            },
          },
        ],
        tableChange: () => {},
        tableParam: {
          pagecount: 10,
        },
        dataApi: dataSource,
        autoRefresh: false, // 设置为true 直接加载grid数据
      },
    });
  };

  /**
   * 完好率按日期图表展示
   */
  stubIntactChart(dataSource) {
    const dataArry = dataSource; // 接口获取数据

    // 设置X轴
    const xAxisData = dataArry.map((item) => {
      return item.day_info;
    });
    let maxVal = 0;
    const failList = [];//失败订单数
    const successList = [];//成功订单数
    const rateList = [];//成功率
    const successListNoMap = [];
    // 处理数据源，转换echarts数据
    dataArry.forEach((v) => {
      // let time = Tool.translateTime(v.date, 'YYYY-MM');
      if (maxVal < v.total_num)
      {
        maxVal = v.total_num;
      }
      successList.push({
        value: v.success_num || 0,
        info: {
          error_num: v.error_num,
          rate: v.rate || 0,
        },
      });
      successListNoMap.push(v.success_num);
      failList.push(v.error_num);
      rateList.push(v.rate);
    });
    maxVal = Math.ceil(Number(maxVal) / 10) * 10;


    const myChart = Echarts.init(document.getElementById("charge-success-firmware-chart1"));
    const option = {
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "cross",
          crossStyle: {
            color: "#999",
          },
        },
        backgroundColor: "rgba(0,0,0,.5)",
        show: true,
        formatter: (params) => {
          let str = "";
          if (params[0].axisValue) {
            str += `<div  style="padding:10px 24px 3px 10px">${params[0].axisValue}</div>`;
            str += `<div  style="padding:3px 24px 3px 10px">成功率：${params[0].value}%，成功订单：${params[1].value}</div>`;
            str += `<div  style="padding:3px 24px 12px 10px">异常订单：${params[2].value}</div>`;
            return str;
          }
        },
        // position: function (pos, params, dom, rect, size) {
        //   // 鼠标在左侧时 tooltip 显示到右侧，鼠标在右侧时 tooltip 显示到左侧。
        //   var obj = { top: 60 };
        //   obj[['left', 'right'][+(pos[0] < size.viewSize[0] / 2)]] = 5;
        //   return obj;
        // }
      },
      color: ["#CDDAE7", "#5B8FF9"],
      legend: {
        selectedMode: false,
        textStyle: {
          padding: [10, 0],
        },
        top: 0,
        itemGap: 15,
        itemWidth: 21,
        itemHeight: 8,
        data: [
          {
            name: "成功率",
          },
          {
            name: "成功订单",
          },
          {
            name: "异常订单",
          },
        ],
      },
      xAxis: [
        {
          type: "category",
          data: xAxisData,
          axisTick: {
            show: false,
          },
          axisLine: {
            lineStyle: {
              color: "rgba(0,0,0,.45)",
            },
          },
          axisLabel: {
            interval: 0,
            margin: 10,
            // rotate: 35,
            textStyle: {
              color: "rgba(0,0,0,.45)",
            },
          },
        },

        {
          type: "category",
          data: xAxisData,
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          axisLabel: {
            show: false,
          },
        },
      ],
      grid: {
        left: "50px",
        right: "50px",
      },
      yAxis: [
        {
          type: "value",
          name: "数量",
          axisLine: { show: false },
          axisTick: { show: false },
          min: 0,
          max: maxVal,
          interval: Math.ceil(maxVal / 10),
          axisLabel: {
            formatter: "{value}",
          },
          nameTextStyle: {
            padding: [0, 25, 10, 0],
            color: "#666",
          },
        },
        {
          type: "value",
          name: "百分比",
          axisLine: { show: false },
          axisTick: { show: false },
          min: 0,
          max: 100,
          interval: 10,
          nameTextStyle: {
            padding: [0, 0, 10, 40],
            color: "#666",
          },
          axisLabel: {
            formatter: "{value}%",
          },
        },
      ],
      series: [
        {
          name: "成功率",
          type: "line",
          symbol: "none",
          itemStyle: {
            color: "#F7C558",
          },
          yAxisIndex: 1,
          // polarIndex: 2,
          data: rateList,
        },
        {
          name: "成功订单",
          type: "bar",
          barWidth: 37,
          yAxisIndex: 0,
          stack: "1",
          barGap: "-100%",
          data: successList,
        },
        {
          name: "异常订单",
          type: "bar",
          yAxisIndex: 0,
          stack: "1",
          data: failList,
          barGap: "-100%",
        },
        
        
      ],
      contentToOption: function () {
        // 数据视图刷新的方法
        // this.stubIntactChart();
      },
    };
    myChart.clear();
    myChart.setOption(option);
  }

  btnChange = (type) => {
    this.setState(
      {
        btnType: type,
      },
      () => {
        if (type === 1) {
          this.stubIntactChart(this.props.dataSource);
        } else {
          this.initTableConfig(this.props.dataSource);
        }
      },
    );
  };

  render() {
    return (
      <Spin spinning={this.props.loading}>
        <div className='section'>
          <div className='title-box' style={{display:"flex", justifyContent:"space-between"}}>
            <div style={{display:"flex", alignItems:"center"}}>
            <div className='title' style={{marginRight:"5px"}}>订单统计数据<Tooltip
                        title={() => <span style={{ color: "#000" }}>检索条件范围内正常停止的订单数及比例和异常停止的订单数的柱状图</span>}
                        color='#ffffff'
                        overlayClassName='white-tooltip'>
                        <QuestionCircleFilled
                          style={{
                            color: "#D9D9D9",
                            marginLeft: "4px",
                            top: "1px",
                          }}
                        />
                      </Tooltip></div>
            <div style={{marginRight:"5px"}} className='btn-switch-box'>
              <span
                className={this.state.btnType === 1 && "selected-btn"}
                onClick={() => this.btnChange(1)}>
                图
              </span>
              <span
                className={this.state.btnType === 2 && "selected-btn"}
                onClick={() => this.btnChange(2)}>
                表
              </span>
            </div>

            <div style={{    display: 'flex',alignItems: 'center'}}>
                <Button
                onClick={this.handleClick}
                type="primary"
                style={{ margin: "5px" }}>
                导出
              </Button>
              </div>
              </div>

              
              {/* <div className="search-box">
                  <span className="select-label"></span>
                  <Select
                    style={{ width: "120px", marginRight: "8px" }}>
                      {this.state.areaList.map((v) => (
                    <Select.Option value={v.value}>{v.text}</Select.Option>
                  ))}
                  </Select>
                  <TreeSelect
                    style={{ width: "200px" }}
                    treeData={this.state.quanguoCityArry}
                    onChange={this.changeCityData}
                    placeholder={'请选择地区'}
                    allowClear
                    className="form-core-tree-select"
                    showSearch
                    treeCheckable={true}
                    treeCheckStrictly={false}
                    treeNodeFilterProp="title"
                    showCheckedStrategy={'SHOW_PARENT'}
                  />

                </div> */}
          </div>
          {this.state.btnType === 1 ? (
            <div
              style={{ width: "100%", height: 420, overflowY: "auto" }}
              id='charge-success-firmware-chart1'
            />
          ) : (
            <ScGridTable config={this.state.tableConfig} />
          )}
        </div>
      </Spin>
    );
  }
}

export default OrderNumType;



// WEBPACK FOOTER //
// ./src/AntD/pages/indicatorReport/chargeSuccessRate/orderNumType.js